import { apiActionCreator } from '../helpers';
import { organizations } from '../../services/api.admin';
import { contextReadySelector, organizationsAsOptions } from '../../selectors/admin/context';
import { ADMIN_CONTEXT } from '../../constants/actions';
import { ADMIN_ROOT_PATH, ADMIN_ORG_DETAILS_PATH } from '../../constants/routes';
import { push } from 'react-router-redux';
import { currentUserSelector, highestRoleSelector, preferencesSelector } from '../../selectors/authentication';
import { savePreferences } from '../authentication';
import { currentPath } from '../../selectors/router';

export function fetchOptions() {
    return async dispatch => {
        await apiActionCreator(
            dispatch,
            () => organizations.get({ sort: 'name', page: 1, resultsPerPage: 99 }),
            response => {
                dispatch({
                    type: ADMIN_CONTEXT.OPTIONS,
                    options: organizationsAsOptions(response.organizations)
                });
            }
        );
    };
}

export function switchContext(id) {
    return (dispatch, getState) => {
        savePreferences(false, { context: id })(dispatch, getState);
        return dispatch(push(id ? ADMIN_ORG_DETAILS_PATH.replace(':context', id) : ADMIN_ROOT_PATH));
    };
}

export function setContext(id) {
    return (dispatch, getState) => {
        const prefs = preferencesSelector(getState());
        const ready = contextReadySelector(getState());
        const path = currentPath(getState());
        const remember = !ready && prefs.context;
        let subject = remember || id;
        if (path === ADMIN_ROOT_PATH) {
            dispatch(push(subject ? ADMIN_ORG_DETAILS_PATH.replace(':context', subject) : ADMIN_ROOT_PATH));
        }
        dispatch({
            type: ADMIN_CONTEXT.SET,
            subject,
            contextRole: highestRoleSelector(subject, currentUserSelector(getState()).roles)
        });
    };
}
